import { Link } from 'react-router-dom';
import Nav from '../components/Nav';
import Footer from '../components/Footer';

export default function HowItWorks() {
  const steps = [
    {
      n: '01', tag: 'Browse',
      title: 'Pick a location.',
      body: "Curated locations across Manhattan. Each one publishes its own package: price per head, what's included, what days. Filter by neighborhood, vibe, headcount.",
    },
    {
      n: '02', tag: 'Invite',
      title: 'Share one link.',
      body: 'Drop it in Slack. Teammates RSVP in two taps. No Goaround account needed. You see the headcount climb in real time.',
    },
    {
      n: '03', tag: 'Pre-pay',
      title: 'One card, one receipt.',
      body: 'Your company card runs once. We settle with the bar after. Finance gets one clean line item.',
    },
    {
      n: '04', tag: 'Show up',
      title: 'Be the hero.',
      body: 'Walk in. Give the name. Walk out. No check.',
    },
  ];

  return (
    <>
      <Nav />
      <section style={{ paddingTop: 56, paddingBottom: 64 }}>
        <div className="container-narrow">
          <div className="eyebrow" style={{ marginBottom: 22 }}>How it works</div>
          <h1 className="display" style={{ fontSize: 'clamp(48px, 7vw, 96px)', margin: 0 }}>
            Slack ping to <span className="serif-italic" style={{ color: 'var(--wine)' }}>cheers</span>, in three minutes.
          </h1>
          <p style={{ fontSize: 20, color: 'var(--ink-soft)', marginTop: 24, maxWidth: 640 }}>
            Four steps. None of them awkward.
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container-narrow">
          {steps.map((s, i) => (
            <div key={s.n} className="hiw-step" style={{ padding: '40px 0', borderTop: i === 0 ? '1.5px solid var(--ink)' : '1px solid var(--line)' }}>
              <div>
                <div className="display" style={{ fontSize: 56, color: 'var(--primary)', lineHeight: 1 }}>{s.n}</div>
                <span className="mono" style={{ marginTop: 12, display: 'inline-block', fontSize: 11, letterSpacing: '0.14em', textTransform: 'uppercase', padding: '6px 10px', border: '1px solid var(--ink)', borderRadius: 999 }}>{s.tag}</span>
              </div>
              <div>
                <h3 className="display" style={{ fontSize: 36, margin: '0 0 14px' }}>{s.title}</h3>
                <p style={{ color: 'var(--ink-soft)', fontSize: 17, margin: 0, lineHeight: 1.55, maxWidth: 600 }}>{s.body}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section style={{ padding: '64px 0 120px' }}>
        <div className="container-narrow" style={{ textAlign: 'center' }}>
          <Link to="/locations" className="btn btn-pop">Plan a night →</Link>
        </div>
      </section>

      <Footer />
    </>
  );
}
